import { useDispatch, useSelector } from "react-redux"
import { Chip, Stack, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useEffect, useState } from "react";
import SortOptions from "./SortOptions";
import styled from "@emotion/styled";
import axios from "axios";
import { endpoint } from "../../../config";
import { updateQuery, updateQueryGenres, updateVideos } from "../../../reduxStore";

function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}

export default function Genres(props) {
    const { genres } = useSelector(state => state.filters)
    // console.log(genres)
    const query = useSelector(state => state.query)

    const dispatch = useDispatch()

    const [selectedGenres, setSelectedGenres] = useState(['All'])

    const forceUpdate = useForceUpdate();

    const handleGenre = (newSelectedGenre) => {
        forceUpdate()
        const removeGenre = () => {
            if(selectedGenres.length == 1) return null
            // selectedGenres.splice(selectedGenres.indexOf(newSelectedGenre), 1)
            const indexOfNewSelectedGenre = selectedGenres.indexOf(newSelectedGenre)
            setSelectedGenres([...selectedGenres.slice(0, indexOfNewSelectedGenre), ...selectedGenres.slice(indexOfNewSelectedGenre+1)])
        }

        if (newSelectedGenre == 'All') setSelectedGenres([newSelectedGenre])
        else {
            selectedGenres.includes('All') 
                ? setSelectedGenres([newSelectedGenre]) 
                : selectedGenres.includes(newSelectedGenre)
                    ? removeGenre()
                    : setSelectedGenres([...selectedGenres, newSelectedGenre])
        }
    }
    
    useEffect(() => {
        console.log(selectedGenres)
    }, [selectedGenres])

    const filterVideos = async () => {
        let url = `${endpoint}?genres=${query.genres.join(',')}`
        if(query.contentRating) url += `&contentRating=${query.contentRating.replace(/\+$/g, '%2B')}`
        if(query.title) url += `&title=${query.title}`
        // console.log(url)
        const res = await axios.get(url)
        // const res = await axios.get(`${endpoint}?genres=${selectedGenres.join(',')}`)
        dispatch(updateVideos(res.data.videos))
        // console.log(res.data.videos)
    }

    useEffect(() => {
        dispatch(updateQueryGenres(selectedGenres))
        if (selectedGenres.length) filterVideos()
    }, [selectedGenres])

    return (
        <Stack 
            className="genres" 
            direction='row' 
            justifyContent='space-around' 
            alignItems='center' 
            sx={{
                width: "100%",
                maxWidth: 680,
                padding: '0.5rem'
            }}
            flexWrap={window.innerWidth < 720 ? 'wrap' : 'nowrap'}
        >
            <Stack flexWrap='wrap' direction='row' justifyContent='center' sx={{width: '100%'}}>
                <Chip 
                    key="All"
                    label='All Genres' 
                    onClick={() => handleGenre('All')}
                    color={selectedGenres.includes('All') ? 'secondary' : 'primary'}
                    sx={{
                        margin: '5px'
                    }}
                />
                {
                    genres.map(genre => (
                        <Chip 
                            key={genre}
                            label={genre} 
                            onClick={() => handleGenre(genre)}
                            color={selectedGenres.includes(genre) ? 'secondary' : 'primary'}
                            sx={{
                                margin: '5px'
                            }}
                        />
                    ))
                }
            </Stack>
            <SortOptions />
        </Stack>
    )
}

const StyledDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;    
`